<template>
  <section v-if="areDimensions || (!isServer() && isEditorActive())" class="interactive-map">
    <div ref="mapContainer" class="interactive-map__map"></div>
  </section>
</template>

<script setup>
import { onMounted, ref, computed } from 'vue';
import { isServer, isEditorActive } from '@sitecore-jss/sitecore-jss/utils';
import { useHead } from '@unhead/vue';
import pickPinIcons from '../../assets/pins/_pins';
import { useAppStore } from '../../stores/appStore';
import { useJssStore } from '../../stores/jssStore';

const appStore = useAppStore();
const jssStore = useJssStore();

const props = defineProps({
  fields: {
    type: Object,
    default: () => ({}),
  },
  rendering: {
    type: Object,
  },
  params: {
    type: Object,
    default: () => ({}),
  },
});

const NOT_SELECTED_PIN = 'mapPinIconNormal';
const DEFAULT = 'default';

const mapContainer = ref(null);
const areDimensions = computed(() => {
  return !!(props.fields.venueLatitude?.value && props.fields.venueLongitude?.value);
});

onMounted(() => {
  if (jssStore.woosmapApiKey && areDimensions.value && appStore.isMapApiLoaded) initMap();
});

const initMap = () => {
  const lat = areDimensions.value ? Number.parseFloat(props.fields.venueLatitude?.value) : null;
  const lng = areDimensions.value ? Number.parseFloat(props.fields.venueLongitude?.value) : null;

  const map = new window.woosmap.map.Map(mapContainer.value, {
    center: { lat, lng },
    zoom: 17,
  });

  const marker = new window.woosmap.map.Marker({
    position: { lat, lng },
    icon: {
      url: props.fields.mapPin?.value || pickPinIcons(DEFAULT)[NOT_SELECTED_PIN],
      scaledSize: new window.woosmap.map.Size(35, 35),
    },
  });
  if (areDimensions.value) marker.setMap(map);
};

!appStore.isMapApiLoaded &&
  jssStore.woosmapApiKey &&
  areDimensions.value &&
  useHead(
    {
      script: [
        {
          key: 'map-api',
          src: `https://sdk.woosmap.com/map/map.js?key=${jssStore.woosmapApiKey}`,
          defer: true,
          onload: () => {
            initMap();
            appStore.setMapApiLoaded();
          },
        },
      ],
    },
    { mode: 'client' }
  );
</script>

<style lang="scss">
@import './scss/InteractiveMap.scss';
</style>
